var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { dragActive as dragActiveCss, large as largeCss, embedded as embeddedCss } from '../styles';
import { dragActive as dragActiveCssCitron, large as largeCssCitron, embedded as embeddedCssCitron, } from '../styles/citron';
import { Droparea as XDroparea, DropareaPlaceholder } from './Droparea.styled';
import { getAutomation, getDebug, getStyleNames } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { isNotNullOrEmpty } from '@pcty/utils';
var VERSION = '2.3.1';
var Droparea = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, _c = _a.dragActive, dragActive = _c === void 0 ? false : _c, _d = _a.embedded, embedded = _d === void 0 ? false : _d, _e = _a.large, large = _e === void 0 ? false : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.placeholderText, placeholderText = _g === void 0 ? '' : _g, css = _a.css, _h = _a.__TYPE, TYPE = _h === void 0 ? 'Droparea' : _h, other = __rest(_a, ["automationId", "children", "className", "dragActive", "embedded", "large", "placeholder", "placeholderText", "css", "__TYPE"]);
    var citrus2022 = useTheme().citrus2022;
    var isCitron = citrus2022 !== null && citrus2022 !== void 0 ? citrus2022 : false;
    var largeTheme = isCitron ? largeCssCitron : largeCss;
    var embeddedTheme = isCitron ? embeddedCssCitron : embeddedCss;
    var dragActiveTheme = isCitron ? dragActiveCssCitron : dragActiveCss;
    var emotionObj = (_b = {},
        _b[emotionCss(largeTheme)] = large,
        _b[emotionCss(embeddedTheme)] = embedded,
        _b[emotionCss(dragActiveTheme)] = dragActive,
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b);
    var classes = cx(emotionObj, className || '');
    var styleNames = {
        large: emotionObj[emotionCss(largeTheme)],
        embedded: emotionObj[emotionCss(embeddedTheme)],
        dragActive: emotionObj[emotionCss(dragActiveTheme)],
    };
    var Component = (placeholder ? DropareaPlaceholder : XDroparea);
    return (React.createElement(Component, __assign({ className: classes, ref: ref, styleNames: getStyleNames(styleNames) }, (placeholder ? { placeholderText: placeholderText } : undefined), other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)), children));
});
Droparea.defaultProps = {
    __TYPE: 'Droparea',
};
export default Droparea;
